import { lexicalHasContent } from '@/app/buy/seller/[sellerSlug]/content/cmsSellerProfileAbout'
import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'

/** Lexical JSON for the accept-terms page body, as the CMS stores it. */
export type CmsTermsBody = Record<string, unknown>

/**
 * The accept-terms page body an editor wrote for this seller, or `null` when the tab is empty
 * (or there is no profile), which keeps today's rendering. One check for both the storefront
 * page and the LDP, so "no CMS terms content" means the same thing on each.
 */
export function cmsTermsFromProfile(
  profile: CmsSellerProfile | null | undefined
): CmsTermsBody | null {
  const body = profile?.termsBody
  return body && lexicalHasContent(body) ? body : null
}
